export default __webpack_public_path__ + "static/media/Amazon.5c55bc5f.svg";